export default {
  banner: {
    description:
      'Consigue {{range}} de descuento al pedir a través de la app gratuita de FoodAmigos. Haz clic aquí para obtenerla →',
  },
  labels: {
    deals: 'Ofertas',
    collecting_points: '¿Ya acumulas puntos?',
    earn_points: 'Gana puntos y obtén recompensas ',
    order_again: 'Pedir de nuevo',
  },
  checkout_button: {
    title: 'Ir a la cesta',
  },
};
